import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { ICreateAssignmentFormData, ICreateAssignmentResponse } from "./types";

export const createAssignment = async (formData: ICreateAssignmentFormData): Promise<ICreateAssignmentResponse> => {

  try {
    const response = await apiClientSource.post("/task-service/api/task-assignments", formData);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al crear la asignación");
    throw error;
  }

};